import React from 'react';
import Link from '../Link';

const siteMap = [
  {
    id: 0,
    title: 'Simply Retirement by <span class="fs-mark-reg">Principal</span>',
    path: '/financial-professionals',
    children: [
      {
        id: 0,
        title: 'Why Choose Us?',
        path: '/financial-professionals/why-simply-retirement',
      },
      {
        id: 1,
        title: '401(k)',
        path: '/financial-professionals/retirement-plans',
      },
      { id: 2, title: 'Set Up a Plan', path: '/plans' },
    ],
  },
  {
    id: 4,
    title:
      'Simply Retirement by <span class="fs-mark-reg">Principal</span> for Business Owners',
    path: '/business-owners',
  },
  {
    id: 1,
    title: 'Retirement Plans',
    path: '/financial-professionals/why-simply-retirement',
    children: [
      {
        id: 0,
        title:
          '<span class="fs-mark-reg">Principal</span> and Ubiquity Retirement + <span class="fs-mark-reg">Savings</span>',
        path: '/financial-professionals/about',
      },
      {
        id: 1,
        title: 'Terms of Use',
        path: 'https://www.principal.com/terms-of-use',
      },
      {
        id: 2,
        title: 'Privacy',
        path: 'https://www.principal.com/privacy-policies',
      },
      {
        id: 3,
        title: 'Security',
        path: 'https://www.principal.com/security-policies',
      },
    ],
  },
  {
    id: 2,
    title: 'Support',
    path: '/financial-professionals/resources',
    children: [
      { id: 0, title: 'Resources', path: 'financial-professionals/resources' },
      {
        id: 3,
        title: 'Your account',
        path: 'https://simplyretirement.ephibian.net/login',
      },
    ],
  },
];

const AdvisorSiteLinkList = () =>
  siteMap.map((link) => {
    switch (!!link.children) {
      case true:
        return (
          <div key={link.id} className="d-inline-block w-100 mb-4  pr-lg-5">
            <h5 className="fs-h5 font-weight-bold">
              <Link to={link.path} className="text-white">
                <span dangerouslySetInnerHTML={{ __html: link.title }} />
              </Link>
            </h5>
            <ul className="list-unstyled text-white mb-3">
              {link.children.map((child) => (
                <li key={child.id} className="mb-2">
                  <Link to={child.path} className="fs-h6 text-white">
                    <span dangerouslySetInnerHTML={{ __html: child.title }} />
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        );
      case false:
        return (
          <div key={link.id} className="d-inline-block w-100 mb-4 pr-lg-5">
            <h5 className="fs-h5 font-weight-bold mb-3">
              <Link to={link.path} className="text-white">
                <span dangerouslySetInnerHTML={{ __html: link.title }} />
              </Link>
            </h5>
          </div>
        );
      default:
        return false;
    }
  });

export default AdvisorSiteLinkList;
